
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store-analytics-mcp",
      function () {
        return require("private-next-pages/store-analytics-mcp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store-analytics-mcp"])
      });
    }
  